import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
//redux
import { useDispatch, useSelector } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Container,
  UncontrolledTooltip,
} from "reactstrap"
import toast from "toastr"
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//import components
import { ActiveValue, TableValue, Date, TableValueEmail } from "./ManageUserCol"
import "./managesettingstoggle.scss"
import UserSettingForm from "./UserFormSetting"
import { getUsersList, postuploadData } from "store/userlist/action"
import { getallAcessGroup } from "store/accessgroupsetting/action"
import SearchForm from "./searchForm"
import ManageSettingsTableContainer from "../Components/ManageSettingsTableContainer"
import UploadForm from "./uploadFormSetting"
import MobileResize from "common/Resize/MobileResize"
function ManageUser() {
  //meta title
  document.title = "ManageUsers | TenderSoftware - Flexi TracBoard"

  const dispatch = useDispatch()

  const [modal, setModal] = useState(false)
  const [uploadmodal, setuploadModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [pageSize, setpageSize] = useState(10)
  const [pageindex, setpageindex] = useState(0)
  const [selectedRow, setselectedRow] = useState({})
  const [showHide, setshowHide] = useState(null)
  const [searchKey, setsearchKey] = useState("")
  const [sort, setSort] = useState({
    direction: "Ascending",
    accessor: "useremail",
  })
  const [isMobile, setIsMobile] = useState(window.innerWidth < 921)

  const companyid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data
    ?.companysetting?.companyid

  const getUserListAPI = value => {
    dispatch(
      getUsersList(
        value === "initialcall"
          ? {
              pageNumber: pageindex,
              pageSize: pageSize,
            }
          : {
              pageNumber: 1,
              pageSize: pageSize,
              searchKey: columnaccessor.accessor,
              searchValue:
                columnaccessor?.dataType === "string"
                  ? searchKey
                  : showHide === "yes"
                  ? "True"
                  : "False",
            }
      )
    )
    // setpageindex(0)
  }

  // Handle API Call
  useEffect(() => {
    getUserListAPI("initialcall")
    dispatch(getallAcessGroup())
  }, [])
  const handleSubmit = e => {
    e.preventDefault()
    getUserListAPI()
  }
  // Reducer

  const {
    userListData,
    addSuccess,
    updatesuccess,
    accessgrouplist,
    accessSetting,
  } = useSelector(state => ({
    userListData: state?.userlist?.userlist,
    addSuccess: state?.userlist?.newUser,
    updatesuccess: state?.userlist?.updateUser,
    accessgrouplist: state?.accessgroup?.accessgrouplist,
    accessSetting: state?.Login?.accessDetails?.data,
  }))
  const hideAddUserbutton = accessSetting?.createUser

  useEffect(() => {
    if (addSuccess?.statusCode === 200 || updatesuccess?.statusCode === 200) {
      getUserListAPI()
    }
  }, [addSuccess, updatesuccess])
  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "Email",
        accessor: "useremail",
        disableFilters: true,
        sort: true,
        sortDirection: sort.accessor === "useremail" ? sort.direction : "none",
        Cell: cellProps => {
          return <TableValueEmail {...cellProps} />
        },
        dataType: "string",
      },
      {
        Header: "First Name",
        accessor: "firstname",
        sort: true,
        disableFilters: true,
        sortDirection: sort.accessor === "firstname" ? sort.direction : "none",
        Cell: cellProps => {
          return <TableValue {...cellProps} />
        },
        dataType: "string",
      },
      {
        Header: "Last Name",
        accessor: "lastname",
        sort: true,
        disableFilters: true,
        sortDirection: sort.accessor === "lastname" ? sort.direction : "none",
        Cell: cellProps => {
          return <TableValue {...cellProps} />
        },
        dataType: "string",
      },
      {
        Header: "User Id",
        accessor: "userIdentificationNumber",
        sort: true,
        disableFilters: true,
        sortDirection:
          sort.accessor === "userIdentificationNumber"
            ? sort.direction
            : "none",
        Cell: cellProps => {
          return <TableValue {...cellProps} />
        },
        dataType: "string",
      },
      {
        Header: "Role",
        accessor: "accessgroupname",
        disableFilters: true,
        sort: true,
        sortDirection:
          sort.accessor === "accessgroupname" ? sort.direction : "none",
        Cell: cellProps => {
          return <TableValue {...cellProps} />
        },
        dataType: "string",
      },
      {
        Header: "View Only",
        accessor: "viewonly",
        disableFilters: true,
        sort: false,
        //  sortDirection: sort.accessor === "viewonly" ? sort.direction : "none",
        Cell: row => (
          <div style={{ textAlign: !isMobile ? "center": "start" }}>
            <ActiveValue {...row} />
          </div>
        ),
        dataType: "boolean",
        dataName: "viewonly",
      },
      {
        Header: "Show Realtime",
        accessor: "showRealTime",
        disableFilters: true,
        sort: false,
        //  sortDirection: sort.accessor === "showRealTime" ? sort.direction : "none",
        Cell: row => (
          <div style={{ textAlign: !isMobile ? "center": "start" }}>
            <ActiveValue {...row} />
          </div>
        ),
        dataType: "boolean",
        dataName: "showRealTime",
      },
      {
        Header: "Contact Number",
        accessor: "contactnumber",
        disableFilters: true,
        sort: true,
        sortDirection:
          sort.accessor === "contactnumber" ? sort.direction : "none",
        Cell: cellProps => {
          return <TableValue {...cellProps} />
        },
        // dataType: "string",
      },
      {
        Header: "Active",
        accessor: "active",
        disableFilters: true,
        sort: false,
        //  sortDirection: sort.accessor === "active" ? sort.direction : "none",
        Cell: row => {
          return (
            <div style={{ textAlign: !isMobile ? "center": "start" }}>
              <ActiveValue {...row} />
            </div>
          )
        },
        // dataType: 'boolean'
      },
      {
        Header: "Activated Date",
        accessor: "activatedDate",
        disableFilters: true,
        sort: true,
        sortDirection:
          sort.accessor === "activatedDate" ? sort.direction : "none",
        Cell: cellProps => {
          return <Date {...cellProps} />
        },
      },
      {
        Header: "App Version ",
        accessor: "lastusedversion",
        disableFilters: true,
        sortDirection:
          sort.accessor === "lastusedversion" ? sort.direction : "none",
        sort: true,
      },
      {
        Header: "Action",
        accessor: "hideeditButton",
        disableFilters: true,
        isDummyField: true,
        Cell: cellProps => {
          return (
            <div
              role="buttton "
              style={{ cursor: "Pointer", textAlign: !isMobile ? "center": "start" }}
            >
              <div
                onClick={e => {
                  handleUserEditGroup(cellProps.row.original)
                }}
              >
                <span className={""}>
                  <i
                    className={"mdi mdi-square-edit-outline md-squaree-edit"}
                    id="Edit"
                    style={{ fontSize: "16px" }}
                  />
                  <UncontrolledTooltip
                    placement="top"
                    target="Edit"
                    className="text-white"
                  >
                    Edit
                  </UncontrolledTooltip>
                </span>
              </div>
            </div>
          )
        },
      },
    ]
    return result
  }, [showHide, sort, isMobile])

  const filteredColumn = columns
    .filter(el => el?.dataType)
    ?.map(el => ({
      ...el,
      label: el.Header,
      value: el.accessor,
    }))

  const [columnaccessor, setColumnaccessor] = useState(filteredColumn[0])

  const tableFilter = value => {
    setColumnaccessor(value)
    if (value?.accessor == "viewonly" || value?.accessor == "showRealTime") {
      getUserListAPI("initialcall")
    }
  }

  const handleCancel = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }

  const toggle = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  const uploadtoggle = () => {
    if (uploadmodal) {
      setuploadModal(false)
    } else {
      setuploadModal(true)
    }
  }

  const handleAddnewUser = arg => {
    setIsEdit(false)
    toggle()
  }
  const handlebulkUpload = arg => {
    uploadtoggle()
  }

  const handleUserEditGroup = data => {
    if (data !== null) {
      setIsEdit(true)
      setselectedRow(data)
    } else {
      validation.resetForm()
      setIsEdit(false)
    }
    toggle()
  }
  const uploadData = value => {
    if (value?.length === 0) {
      toast.error("Please Upload File")
    } else {
      var datas = new FormData()
      value.map(selectedFile => {
        datas.append("file", selectedFile)
      })
      dispatch(postuploadData(datas, handleResponse))
    }
  }

  const handleResponse = status => {
    if (status === "SUCCESS") {
      uploadtoggle()
    }
  }
  const handlePageValue = value => {
    if (!value.noChange) setpageindex(value.pageNumber)
    setpageSize(value.pageSize)
    dispatch(
      getUsersList({
        ...value,
        pageNumber: value.pageNumber + 1,
        sortKey: value.sortKey,
        sortValue: value.sortValue,
        searchKey: columnaccessor.accessor,
        searchValue:
          columnaccessor?.dataType === "string"
            ? searchKey
            : showHide === "yes"
            ? "True"
            : "False",
      })
    )
  }
  useEffect(() => {
    if (showHide !== null) {
      getUserListAPI()
    }
  }, [showHide])

  const columnHeaderClick = (column, pagesize, pageIndex) => {
    switch (column.sortDirection) {
      case "none":
        setSort({ direction: "Ascending", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          sortKey: column.id,
          sortValue: "Ascending",
        })
        break
      case "Ascending":
        setSort({ direction: "Descending", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          sortKey: column.id,
          sortValue: "Descending",
        })
        break
      case "Descending":
        setSort({ direction: "Ascending", accessor: column.id })
        handlePageValue({
          pageSize: pagesize,
          pageNumber: pageIndex,
          sortKey: column.id,
          sortValue: "Ascending",
        })
        break
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs="12">
              <Breadcrumbs
                title={"Manage Users"}
                breadcrumbItem={"Manage Users"}
              />
              <Card>
                <CardBody className="table-mobileView">
                  <SearchForm
                    handleSubmit={handleSubmit}
                    handleAddnewUser={handleAddnewUser}
                    columns={filteredColumn}
                    setshowHide={setshowHide}
                    tableFilter={tableFilter}
                    columnaccessor={columnaccessor}
                    setsearchKey={setsearchKey}
                    searchKey={searchKey}
                    hideAddUserbutton={hideAddUserbutton}
                    handlePageValue={handlePageValue}
                    getUserListAPI={getUserListAPI}
                    setpageindex={setpageindex}
                  />
                                    <MobileResize setIsMobile={setIsMobile}>
                    <ManageSettingsTableContainer
                      keyField="id"
                      data={userListData?.data || []}
                      columns={columns}
                      isGlobalFilter={false}
                      isAddOptions={false}
                      handlePageValue={handlePageValue}
                      customPageSize={10}
                      className="custom-header-css"
                      totalCount={userListData?.count || 0}
                      pageindex={pageindex}
                      setpageindex={setpageindex}
                      handleUserEditGroup={handleUserEditGroup}
                      handleAddnewUser={handleAddnewUser}
                      customPageSizeOptions
                      buttonHide={true}
                      filters={true}
                      handlebulkUpload={handlebulkUpload}
                      colspanChange={true}
                      hideAddUserbutton={hideAddUserbutton}
                      onHeaderClick={columnHeaderClick}
                      accessGroup={true}
                    />
                  </MobileResize>
                  <Modal isOpen={modal} toggle={toggle} size="lg">
                    <ModalHeader toggle={toggle} tag="h4">
                      {isEdit ? "Edit User Settings" : "Add New User"}
                    </ModalHeader>
                    <ModalBody>
                      <UserSettingForm
                        companyid={companyid}
                        isEdit={isEdit}
                        selectedRow={selectedRow}
                        toggle={toggle}
                        handleCancel={handleCancel}
                        accessgrouplist={accessgrouplist}
                      />
                    </ModalBody>
                  </Modal>

                  {/*  handle bulk upload modal */}
                  <Modal isOpen={uploadmodal} toggle={uploadtoggle} size="lg">
                    <ModalHeader toggle={uploadtoggle}>
                      {"Add Bulk Upload  User"}
                    </ModalHeader>
                    <ModalBody>
                      <UploadForm uploadData={uploadData} />
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ManageUser.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default ManageUser
